__turbopack_context__.v({
  "container": "ButtonSearch-module__uBOIaq__container",
  "fadeInItems": "ButtonSearch-module__uBOIaq__fadeInItems",
  "spacing--lg": "ButtonSearch-module__uBOIaq__spacing--lg",
  "spacing--md": "ButtonSearch-module__uBOIaq__spacing--md",
  "spacing--sm": "ButtonSearch-module__uBOIaq__spacing--sm",
  "spacing--xl": "ButtonSearch-module__uBOIaq__spacing--xl",
  "spacing--xs": "ButtonSearch-module__uBOIaq__spacing--xs",
  "spacing--xxl": "ButtonSearch-module__uBOIaq__spacing--xxl",
  "spacing--xxs": "ButtonSearch-module__uBOIaq__spacing--xxs",
  "spacing--xxxl": "ButtonSearch-module__uBOIaq__spacing--xxxl",
  "spacing--xxxs": "ButtonSearch-module__uBOIaq__spacing--xxxs",
});
